import { type Column } from "~/ui/Table/types";

export const TOKEN_TRANSFER_COLUMN: Array<Column> = [
  {
    name: "TXN HASH",
    field: "transactionHash",
  },
  {
    name: "AGE",
    field: "age",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "DATETIME",
    field: "unixTimeStamp",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "METHOD",
    field: "method",
  },
  {
    name: "FROM",
    field: "fromAddressInfo",
  },
  {
    name: "",
    field: "arrow-right",
  },
  {
    name: "TO",
    field: "toAddressInfo",
  },
  {
    name: "AMOUNT",
    field: "amount",
    isHoverable: true,
  },
  {
    name: "TOKEN",
    field: "tokenInfo",
    isHoverable: true,
  },
];

export const NFT_TRANSFER_COLUMN: Array<Column> = [
  {
    name: "TXN HASH",
    field: "transactionHash",
  },
  {
    name: "AGE",
    field: "age",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "DATETIME",
    field: "unixTimeStamp",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "METHOD",
    field: "method",
  },
  {
    name: "FROM",
    field: "fromAddressInfo",
  },
  {
    name: "",
    field: "arrow-right",
  },
  {
    name: "TO",
    field: "toAddressInfo",
  },
  {
    name: "COLLECTION",
    field: "tokenInfo",
  },
  {
    name: "QUANTITY",
    field: "amount",
  },
  {
    name: "ITEM",
    field: "tokenId",
  },
];

export const ACCOUNT_NFT_TRANSFER_COLUMN: Array<Column> = [
  {
    name: "TXN HASH",
    field: "transactionHash",
  },
  {
    name: "AGE",
    field: "age",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "DATETIME",
    field: "unixTimeStamp",
    isToggleColumn: true,
    isHoverable: true,
  },
  {
    name: "METHOD",
    field: "method",
  },
  {
    name: "FROM",
    field: "fromAddressInfo",
  },
  {
    name: "",
    field: "arrow-right",
  },
  {
    name: "TO",
    field: "toAddressInfo",
  },
  {
    name: "ITEM",
    field: "tokenInfo",
  },
  {
    name: "QUANTITY",
    field: "amount",
  },
  {
    name: "ITEM",
    field: "item",
  },
  {
    name: "COLLECTION",
    field: "collection",
  },
];
